import { Box, Radio } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DataGrid from "../../../../../../table/DataGrid";
import DialogConfirmCancel from "../../../../../../dialog/DialogConfirm";
import useUsers from "../../../../../../../hooks/users/useUsers";
import Avatar from "../../../../../../avatar/Avatar";
import FilterButtonUsersClass from "./Filter/Button";

const DialogStudentSelector = ({ onClose, open, userId, onApply }) => {
  const columnsTable = [
    {
      label: "Photo",
      key: "avatar",
      align: "center",
      className: "text-center",
      show: true,
      hide: false,
    },
    { label: "Code", key: "code", show: true, hide: true },
    { label: "Name", key: "fullName", show: true, hide: true },
    {
      label: "Year Level",
      key: "yearLevelUser",
      show: true,
      hide: true,
    },
    { label: "Form", key: "form", show: true, hide: true },
    { label: "House", key: "house", show: true, hide: true },
  ];
  const list = useSelector((state) => state?.user?.list || []);
  const totalList = useSelector((state) => state?.user?.totalList || []);

  const [userSelected, setUserSelected] = useState(userId);

  const state = useSelector((state) => state?.filter?.usersClass || {});
  const skip = useSelector((state) => state?.datatable?.user?.skip || 0);
  const rowsPerPage = useSelector(
    (state) => state?.datatable?.user?.rowsPerPage || 50
  );

  const { isLoading, isLoadingList, getUsersByRoleId } = useUsers();

  useEffect(() => {
    const filter = state?.filter || {};
    getUsersByRoleId("Student", skip, rowsPerPage, filter);
  }, [rowsPerPage, skip, state?.filter]);

  const onConfirm = async (e) => {
    e.preventDefault();
    const student = list.find((row) => userSelected === row._id);
    onApply(student);
    onClose();
  };

  const onSelected = (id) => {
    setUserSelected(id);
  };

  return (
    <DialogConfirmCancel
      id={`student-selector`}
      open={open}
      disabledConfirm={isLoading}
      onCancel={onClose}
      onConfirm={onConfirm}
      title={`Select student`}
      onCloseHeader={true}
      maxWidth="lg"
    >
      <div className="h-screen-modal-content-footer overflow-auto">
        <Box className="px-4 py-2 h-10 border-b border-b-2 border-primary text-primary-foreground flex items-center justify-between">
          <FilterButtonUsersClass />
        </Box>
        <Box className="absolute top-20 bottom-4 inset-x-4">
          <DataGrid
            id="users"
          nameModule='user'
            rows={list.map((row, index) => {
              const data = row.data || {};
              return {
                ...row,
                index: index + 1 + rowsPerPage * skip,
                avatar: (
                  <div className="flex items-center justify-center">
                    <Avatar
                      size="small"
                      variant="circular"
                      alt={row?.code}
                      src={`photos/${row?.photo}`}
                    />
                  </div>
                ),
                ...data,
                yearLevelUser: row.yearLevel
                  ?.map((yearLevel) => yearLevel.name)
                  .join(", "),
                userSelected: (
                  <Radio
                    id={`radio-id-user-${row._id}`}
                    checked={userSelected === row._id}
                    onChange={() => onSelected(row._id)}
                    color="primary"
                  />
                ),
              };
            })}
            loading={isLoadingList}
            totalRows={totalList.length}
            skip={skip}
            rowsPerPage={rowsPerPage}
            columns={[
              {
                label: "#",
                key: "index",
                align: "center",
                width: 10,
                show: true,
                hide: false,
              },
              {
                show: true,
                key: "userSelected",
                align: "center",
                width: 15,
                label: <></>,
              },
              ...columnsTable,
            ]}
            labelNoRows={`You don't have any students yet`}
          />
        </Box>
      </div>
    </DialogConfirmCancel>
  );
};

export default DialogStudentSelector;
